export default async function askWantsToApply({ state }, listing) {
  state.set('askWantsToApplyToListing', listing);
}
